module.exports = __webpack_public_path__ + "bubble-bg.png?d83d31f95c731ab9dbec163586d8a3e3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bubble-bg.png
// module id = 96
// module chunks = 0